export default "__VITE_ASSET__d44fc45c__"